// Bilingual translations for Aarón Heating & Cooling
export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      areas: "Service Areas",
      contact: "Contact",
      emergency: "Emergency? Call Now",
      whatsapp: "WhatsApp",
    },
    whatsappMessage: "Hi Aarón! I'd like to request a service. Can you help?",
    hero: {
      eyebrow: "Serving DC · Maryland · Northern Virginia",
      title: "Mastering the",
      titleAccent: "DMV Climate.",
      subtitle: "Expert heating & cooling services you can trust — bilingual, licensed, and 30 minutes away.",
      ctaPrimary: "Get a Free Quote",
      ctaSecondary: "Call 240-761-8778",
      stats: [
        { value: "10+", label: "Years in the DMV" },
        { value: "30 min", label: "Response Time" },
        { value: "100%", label: "Licensed & Insured" },
      ],
    },
    services: {
      eyebrow: "What We Do",
      title: "Comfort, every season.",
      subtitle: "From August humidity to January freezes — we keep DMV homes running.",
      items: [
        {
          key: "ac",
          icon: "snowflake",
          title: "AC Installation & Repair",
          desc: "High-efficiency cooling systems and fast repairs for DMV summers.",
          accent: "cool",
        },
        {
          key: "furnace",
          icon: "flame",
          title: "Furnace Repair",
          desc: "Keep your family warm through Maryland and Virginia winters.",
          accent: "warm",
        },
        {
          key: "maintenance",
          icon: "wrench",
          title: "Maintenance Plans",
          desc: "Preventive tune-ups that lower your monthly energy bill.",
          accent: "cool",
        },
        {
          key: "iaq",
          icon: "wind",
          title: "Indoor Air Quality",
          desc: "Filtration and purification systems for cleaner, healthier air.",
          accent: "warm",
        },
      ],
    },
    advantage: {
      eyebrow: "The Aarón Advantage",
      title: "Why DMV homeowners choose us.",
      items: [
        {
          icon: "mapPin",
          title: "Local Expertise",
          desc: "Ten years of pride serving D.C., Maryland, and Northern Virginia.",
        },
        {
          icon: "languages",
          title: "Bilingual Team",
          desc: "Hablamos tu idioma — clear communication from quote to install.",
        },
        {
          icon: "shieldCheck",
          title: "Licensed & Insured",
          desc: "Total peace of mind for every homeowner we serve.",
        },
      ],
      promiseBadge: "We respond in less than 30 minutes during business hours.",
    },
    areas: {
      eyebrow: "Coverage",
      title: "Where we work.",
      subtitle: "Same-day service across the DMV.",
      dc: "Washington, D.C.",
      md: "Maryland",
      va: "Northern Virginia",
    },
    work: {
      eyebrow: "Recent Projects",
      title: "Real installs across the DMV.",
      subtitle: "A few of the homes we've kept comfortable this season.",
      items: [
        {
          title: "Trane Rooftop AC · Package Unit",
          location: "Washington, D.C.",
          tag: "Cooling",
          desc: "Full rooftop replacement next to existing solar — energy-guide rated, no service interruption.",
        },
        {
          title: "Bryant 96% High-Efficiency Furnace",
          location: "Silver Spring, MD",
          tag: "Heating",
          desc: "Modulating gas furnace install with new evap coil and pan — cleaner, quieter, lower bills.",
        },
      ],
    },
    testimonials: {
      eyebrow: "What homeowners say",
      title: "Trusted across DC, MD & VA.",
      subtitle: "Real responses from DMV families we've served.",
      sampleNote: "Some entries are placeholders — replace as more verified reviews come in.",
      items: [
        {
          quote: "These people are amazing — very good, nice, and clean work.",
          name: "Thomas J.",
          location: "Bowie, MD",
          service: "Installation",
        },
        {
          quote: "Super fast and professional — excellent service.",
          name: "Susana R.",
          location: "Rockville, MD",
          service: "AC Repair",
        },
        {
          quote: "I called because my AC stopped cooling in the middle of the heat and they responded the same day. The technician was on time, very friendly, and clearly explained the problem. The repair was fast, the price was fair, and now my system runs better than before. You can tell they work with professionalism and honesty. I'll definitely call them again and recommend them 100%.",
          name: "Carlos V.",
          location: "Richmond, VA",
          service: "AC Repair",
        },
      ],
    },
    quote: {
      eyebrow: "Free Quote",
      title: "Tell us about your project.",
      subtitle: "We respond in under 30 minutes during business hours.",
      labels: {
        name: "Full name",
        phone: "Phone",
        email: "Email",
        service: "Service needed",
        zip: "ZIP Code",
        message: "Tell us a bit more (optional)",
        submit: "Request Free Quote",
        sending: "Sending…",
      },
      services: {
        ac_installation: "AC Installation & Repair",
        furnace_repair: "Furnace Repair",
        maintenance: "Maintenance",
        indoor_air_quality: "Indoor Air Quality",
        emergency: "Emergency Service",
        other: "Other / Not sure",
      },
      success: "Got it! We'll be in touch within 30 minutes.",
      error: "Something went wrong. Please call us at 240-761-8778.",
    },
    footer: {
      tagline: "Bilingual HVAC pros for the DMV — heat, cool, breathe easy.",
      coverage: "Coverage Areas",
      certifications: "Certifications",
      certs: ["EPA Certified", "NATE-Trained", "Licensed & Insured"],
      contact: "Contact",
      address: "10770 Columbia Pike Ste 300 #1313, Silver Spring, MD 20901",
      hours: "Mon–Sat · 7:00 AM – 8:00 PM",
      rights: "All rights reserved.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      about: "Nosotros",
      areas: "Zonas de Cobertura",
      contact: "Contacto",
      emergency: "¿Emergencia? Llama Ya",
      whatsapp: "WhatsApp",
    },
    whatsappMessage: "Hi Aarón! I'd like to request a service. Can you help?",
    hero: {
      eyebrow: "Servimos DC · Maryland · Virginia del Norte",
      title: "Dominamos el",
      titleAccent: "clima del DMV.",
      subtitle: "Servicios expertos de calefacción y aire acondicionado en los que puedes confiar — bilingües, licenciados y a 30 minutos.",
      ctaPrimary: "Obtener Presupuesto Gratis",
      ctaSecondary: "Llama 240-761-8778",
      stats: [
        { value: "10+", label: "Años en el DMV" },
        { value: "30 min", label: "Tiempo de respuesta" },
        { value: "100%", label: "Licenciados y Asegurados" },
      ],
    },
    services: {
      eyebrow: "Qué hacemos",
      title: "Confort en cada estación.",
      subtitle: "Desde la humedad de agosto hasta los fríos de enero — mantenemos los hogares del DMV funcionando.",
      items: [
        {
          key: "ac",
          icon: "snowflake",
          title: "Instalación y Reparación de AC",
          desc: "Sistemas de alta eficiencia y reparaciones rápidas para los veranos del DMV.",
          accent: "cool",
        },
        {
          key: "furnace",
          icon: "flame",
          title: "Reparación de Calefacción",
          desc: "Mantén a tu familia cálida en los inviernos de Maryland y Virginia.",
          accent: "warm",
        },
        {
          key: "maintenance",
          icon: "wrench",
          title: "Planes de Mantenimiento",
          desc: "Mantenimientos preventivos que bajan tu factura de luz.",
          accent: "cool",
        },
        {
          key: "iaq",
          icon: "wind",
          title: "Calidad del Aire Interior",
          desc: "Sistemas de filtración y purificación para aire más limpio.",
          accent: "warm",
        },
      ],
    },
    advantage: {
      eyebrow: "La Ventaja Aarón",
      title: "Por qué los hogares del DMV nos eligen.",
      items: [
        {
          icon: "mapPin",
          title: "Expertos Locales",
          desc: "Diez años con orgullo sirviendo a D.C., Maryland y Virginia del Norte.",
        },
        {
          icon: "languages",
          title: "Equipo Bilingüe",
          desc: "Hablamos tu idioma — comunicación clara desde el presupuesto hasta la instalación.",
        },
        {
          icon: "shieldCheck",
          title: "Licenciados y Asegurados",
          desc: "Tranquilidad total para cada propietario que atendemos.",
        },
      ],
      promiseBadge: "Respondemos en menos de 30 minutos durante horas laborales.",
    },
    areas: {
      eyebrow: "Cobertura",
      title: "Dónde trabajamos.",
      subtitle: "Servicio el mismo día en todo el DMV.",
      dc: "Washington, D.C.",
      md: "Maryland",
      va: "Virginia del Norte",
    },
    work: {
      eyebrow: "Proyectos Recientes",
      title: "Instalaciones reales en el DMV.",
      subtitle: "Algunos de los hogares que hemos mantenido cómodos esta temporada.",
      items: [
        {
          title: "AC Trane en Azotea · Unidad Package",
          location: "Washington, D.C.",
          tag: "Enfriamiento",
          desc: "Reemplazo completo en azotea junto a panel solar existente — clasificación EnergyGuide, sin interrupción del servicio.",
        },
        {
          title: "Calefacción Bryant 96% Alta Eficiencia",
          location: "Silver Spring, MD",
          tag: "Calefacción",
          desc: "Instalación de calefacción modulante a gas con nueva bobina evaporadora — más limpia, silenciosa y económica.",
        },
      ],
    },
    testimonials: {
      eyebrow: "Lo que dicen los clientes",
      title: "Confianza en DC, MD y VA.",
      subtitle: "Respuestas reales de familias del DMV a las que hemos servido.",
      sampleNote: "Algunas entradas son provisionales — reemplázalas a medida que recibas reseñas verificadas.",
      items: [
        {
          quote: "Esta gente es increíble — muy buenos, amables y un trabajo muy limpio.",
          name: "Thomas J.",
          location: "Bowie, MD",
          service: "Instalación",
        },
        {
          quote: "Súper rápidos y profesionales — excelente servicio.",
          name: "Susana R.",
          location: "Rockville, MD",
          service: "Reparación de AC",
        },
        {
          quote: "Llamé porque mi aire acondicionado dejó de enfriar en pleno calor y respondieron el mismo día. El técnico fue puntual, muy amable y explicó claramente cuál era el problema. La reparación fue rápida, el precio justo y ahora mi sistema funciona mejor que antes. Se nota que trabajan con profesionalismo y honestidad. Definitivamente los volveré a llamar y los recomiendo al 100%.",
          name: "Carlos V.",
          location: "Richmond, VA",
          service: "Reparación de AC",
        },
      ],
    },
    quote: {
      eyebrow: "Presupuesto Gratis",
      title: "Cuéntanos sobre tu proyecto.",
      subtitle: "Respondemos en menos de 30 minutos durante horas laborales.",
      labels: {
        name: "Nombre completo",
        phone: "Teléfono",
        email: "Correo",
        service: "Servicio que necesitas",
        zip: "Código Postal",
        message: "Cuéntanos un poco más (opcional)",
        submit: "Solicitar Presupuesto Gratis",
        sending: "Enviando…",
      },
      services: {
        ac_installation: "Instalación y Reparación de AC",
        furnace_repair: "Reparación de Calefacción",
        maintenance: "Mantenimiento",
        indoor_air_quality: "Calidad del Aire Interior",
        emergency: "Servicio de Emergencia",
        other: "Otro / No estoy seguro",
      },
      success: "¡Recibido! Te contactamos en menos de 30 minutos.",
      error: "Algo salió mal. Llámanos al 240-761-8778.",
    },
    footer: {
      tagline: "Profesionales bilingües de HVAC para el DMV — calienta, enfría, respira tranquilo.",
      coverage: "Zonas de Cobertura",
      certifications: "Certificaciones",
      certs: ["Certificado EPA", "Entrenamiento NATE", "Licenciado y Asegurado"],
      contact: "Contacto",
      address: "10770 Columbia Pike Ste 300 #1313, Silver Spring, MD 20901",
      hours: "Lun–Sáb · 7:00 AM – 8:00 PM",
      rights: "Todos los derechos reservados.",
    },
  },
};
